import React from "react";
import PropTypes from "prop-types";
import { usePlanFeature } from "../../hooks/usePlanFeature";
import SchedulingUpsell from "./SchedulingUpsell";

/**
 * SchedulingRoute — bloqueio das telas de AGENDA para tenants cujo plano não
 * inclui agendamento (Plano Atendimento — `plan.schedulingIncluded === false`,
 * ADR-0026). Usado em `App.js`, DENTRO do `AppLayout`, envolvendo o elemento
 * de cada rota de agenda.
 *
 * BLOQUEIA, NÃO ESCONDE (ADR-0026 §Decisão): ao contrário do `RoleRoute`, NÃO
 * redireciona — renderiza o convite de upgrade no lugar do conteúdo, mantendo
 * URL, menu e header. Esconder a tela mataria a descoberta, que é o único motor
 * de upgrade deste tier.
 *
 * FAIL-SAFE: `usePlanFeature("scheduling")` só nega com `false` explícito.
 * Plano ausente, campo ausente ou AuthContext ainda não hidratado → conteúdo
 * liberado, comportamento idêntico ao de antes deste gate existir.
 */
export default function SchedulingRoute({ children }) {
  const { allowed, upgradeUrl } = usePlanFeature("scheduling");
  if (!allowed) return <SchedulingUpsell upgradeUrl={upgradeUrl} />;
  return children;
}

SchedulingRoute.propTypes = {
  children: PropTypes.node,
};
